export const locale = {
    lang: 'pl',
    data: {
        "Employee schedule": "Grafik pracowników",
        "New": "Nowa",
        "Name": "Nazwa",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Device group data": "Dane grupy produktów",
        "Save": "Zapisz",
        "Previous week": "Poprzedni tydzień",
        "Current week": "Aktualny tydzień",
        "Next week": "Następny tydzień",
        "Previous month": "Poprzedni miesiąc",
        "Current month": "Aktualny miesiąc",
        "Next month": "Następny miesiąc"
    }
};
